import React, { useState } from "react";
import { Mail, Bell } from "lucide-react";
import { signupForWaitlist } from "../services/api";

const LaunchingSoon = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setMessage("Please enter your email address");
      setMessageType("error");
      return;
    }

    setIsLoading(true);
    setMessage("");
    setMessageType("");

    try {
      const response = await signupForWaitlist(email.trim());
      
      if (response.success) {
        setMessage(response.message);
        setMessageType("success");
        setEmail(""); // Clear the form on success
      } else {
        setMessage(response.message || "Something went wrong. Please try again.");
        setMessageType("error");
      }
    } catch (error) {
      setMessage(error.message || "Something went wrong. Please try again.");
      setMessageType("error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="launching" className="launching-soon">
      <div className="section-container">
        <div className="launching-content">
          <div className="launching-header">
            <h2 className="section-title">Launching Soon</h2>
            <p className="launching-description">
              We are preparing to roll out our first set of groundbreaking products and services. 
              Be among the first to experience the future of technology with DoubleTap.
            </p>
          </div>

          <div className="signup-section">
            <div className="signup-icon">
              <Bell />
            </div>
            <h3 className="signup-title">Join Our Waitlist</h3>
            <p className="signup-subtitle">
              Get exclusive early access and launch offers delivered straight to your inbox.
            </p>
            
            <form className="signup-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <div className="input-wrapper">
                  <Mail className="input-icon" />
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="email-input"
                    required
                    disabled={isLoading}
                  />
                </div>
                <button 
                  type="submit" 
                  className="notify-button"
                  disabled={isLoading}
                >
                  {isLoading ? "Adding you..." : "Notify Me"}
                </button>
              </div>
            </form>

            {message && (
              <div className={`signup-message ${messageType}`}>
                {message}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LaunchingSoon;